<template lang="pug">
    .page-preloader

</template>

<script>
    // @ is an alias to /src
    import '@/components/common/pagePreloader/pagePreloader.styl';
    import EventBus from '@/eventBus';

    export default {
        name: 'PagePreloader',
        data() {
            return {

            }
        },

        components: {

        },

        created() {
            EventBus.$on('pagePreloaderShow', () => {
                $('.page-preloader').addClass('page-preloader--start');
            });

            EventBus.$on('pagePreloaderHide', () => {
                let $preloader = $('.page-preloader');
                $preloader.addClass('page-preloader--end');
                setTimeout(() => {
                    $preloader.addClass('page-preloader--hide');
                    setTimeout(() => {
                        $preloader.removeClass('page-preloader--end');
                        $preloader.removeClass('page-preloader--start');
                        setTimeout(() => {
                            $preloader.removeClass('page-preloader--hide');
                        }, 200);
                    }, 200);
                }, 400);
            });
        },

        methods: {

        }
    }
</script>
